import { useCallback } from 'react';

import { useLogger } from '@/shared/hooks/useLogger';

import { EnhancedPlayback } from '../lib/enhancedPlayback';

type PlaybackError = NonNullable<EnhancedPlayback['error']['value']>;

interface UseOnErrorParams {
    contentId: string;
    source?: string;
    onError?: (error: PlaybackError) => void;
}

const getErrorMessage = (error: PlaybackError): string => {
    if (!error.code) return 'PlayerError: Player initialization failed';
    return `PlayerError: ${error.code}`;
};

export const useOnError = ({ contentId, source, onError }: UseOnErrorParams) => {
    const logger = useLogger();

    const handleError = useCallback(
        (error: PlaybackError, vsid: string) => {
            const message = getErrorMessage(error);

            logger.error(
                {
                    message,
                    source: 'player',
                    additional: {
                        source,
                        contentId,
                        vsid,
                    },
                    level: 'warn' as const,
                    error,
                },
                message
            );

            onError?.(error);
        },
        [logger, source, contentId, onError]
    );

    return handleError;
};
